import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=6777ddd8&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=ts&"
export * from "./Project.vue?vue&type=script&lang=ts&"
import style0 from "./Project.vue?vue&type=style&index=0&id=6777ddd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777ddd8",
  null
  
)

export default component.exports